<template>
  <div style="background-color: #EDF0F5;text-align: center;padding-bottom: 20px;">
    <van-image :src="detailInfo.headImage" fit="fill" height="236" style="vertical-align: top" width="100%" />
    <div style="background-color: #FFFFFF;text-align: left;width: 100%;">
      <div style="padding: 16px;">
        <span style="font-size: 18px;font-weight: bold;">{{ detailInfo.name }}
        </span>
        <br />

        <van-tag v-if="detailInfo.level > 0" size="large" class="travel-tag-9" type="warning">{{ detailInfo.level }}A景区
        </van-tag>

        <van-tag color="#e7f5ff" size="large" style="margin-right: 4px;margin-top: 8px;" text-color="#29a2ff">
          {{ commentGrade }} / 5分
        </van-tag>
        <br />
        <div style="display: block;margin-top: 16px;line-height: 30px; color: #999999;vertical-align:middle;">
          <van-icon name="location-o" size="20" style="position: relative;top: 3px;" />
          <span> {{ detailInfo.address }}</span>
          <br />
          <span style="color: #999999;">
            <span id="J_description" class="m-content overflow-line" style="">
              <van-icon color="#999999" name="clock-o" size="20" style="position: relative;top: 3px;" />
              {{ noteInfo }}
            </span>
            <a v-if="isShowMore" id="J_btnmore" class="btn-more" @click="showmoreDesc($event)">查看更多</a>
          </span>
        </div>
      </div>
    </div>

    <div style="height: 30px;text-align: left;padding: 8px;display: flex">
      <span style="width: 5px;height: 30px;background: #F23A3A;border-radius: 3px;display:inline-block"> </span>
      <span
        style="font-size: 21px;font-weight: bold;line-height: 30px;height: 30px;display:inline-block;margin-left: 8px;">门票</span>
    </div>

    <div v-if="!goodsList || goodsList.length < 1">
      没有门票
    </div>

    <div v-for="goods in goodsList" :key="goods.goodsId" class="van-hairline--bottom"
      style="padding: 8px;background-color: #FFFFff;margin: 8px;border-radius: 4px;">
      <div style="display: flex;justify-content: space-between">
        <div style="width: 100%;text-align: left">
          <div style="font-weight: bold;color: #333;font-size: 16px;text-align: left">
            {{ goods.name }}
          </div>

          <van-tag v-for="tag of goods.tags" :key="tag" plain size="medium"
            style="margin-right: 8px;display: inline-block;margin-top: 8px;">
            {{ tag }}
          </van-tag>

          <div style="margin-top: 8px;font-size: 12px;color: #999999" @click="show_notice(goods.goodsId)">
            购买须知 >
          </div>
        </div>
        <div
          style="margin-left: 10px;justify-content: space-between;width: 100px;padding-bottom: 8px;align-self: center">
          <div style="display: flex;justify-content: center;">
            <img alt=""
              src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png"
              style="  width: 18px;  height: 18px;align-self: center" />
            <span class="span-price-65">{{ (goods.price / 100).toFixed(2) }} </span>
          </div>

          <div style="display: block;margin-top: 4px;">
            <van-button round size="mini" style="width: 80px" type="danger"
              @click="go_travel_order_create(goods)">预订</van-button>
          </div>

        </div>
      </div>
    </div>

    <!--简介开始-->
    <div style="height: 30px;text-align: left;padding: 8px;display: flex">
      <span style="width: 5px;height: 30px;background: #F23A3A;border-radius: 3px;display:inline-block"> </span>
      <span
        style="font-size: 21px;font-weight: bold;line-height: 30px;height: 30px;display:inline-block;margin-left: 8px;">简介</span>
    </div>
    <div style="padding: 8px;background-color: #FFFFff;margin: 8px;border-radius: 4px;text-align:left"
      v-html="extInfo.ProductDescription">
    </div>
    <!--简介结束-->

    <!--交通开始-->
    <div style="height: 30px;text-align: left;padding: 8px;display: flex">
      <span style="width: 5px;height: 30px;background: #F23A3A;border-radius: 3px;display:inline-block"> </span>
      <span
        style="font-size: 21px;font-weight: bold;line-height: 30px;height: 30px;display:inline-block;margin-left: 8px;">交通</span>
    </div>
    <div style="padding: 8px;background-color: #FFFFff;margin: 8px;border-radius: 4px;text-align:left">
      <div v-html="extInfo.Traffic"></div>
      <div style="height: 500px; margin-top: 16px;">
        <iframe id="iframe" :src="mapUrl" frameborder="0" height="500" scrolling="auto" width="100%"></iframe>
      </div>
    </div>
    <!--交通结束-->

    <van-popup v-model="noticeShow" :style="{ height: '50%', padding: '8px', fontSize: '12px' }" closeable
      position="bottom">
      <div v-for="(notice, index) in noticeInfo" :key="index" style="text-align: left;">
        <p style="font-weight: bold;font-size: 21px;">{{ index }}</p>
        <div v-for="(subNotice, sindex) in notice" :key="sindex" style="">
          <p style="">
            <van-tag color="#ff7700" plain size="medium">{{ sindex }}</van-tag>
          </p>
          <ul>
            <li v-for="(subContent, i) in subNotice" :key="i" style="margin-left: 8px;line-height: 25px;">
              {{ subContent }}
            </li>
          </ul>
        </div>
        <div style="height: 1px; background-color: #999; transform:scaleY(0.5);margin: 16px 4px"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Dialog } from "vant"
import { api_get_ctrip_goods_list, getHospitalDetail } from "@/api/goods-api";

export default {
  name: "detail",

  data() {
    return {
      detailInfo: {},
      extInfo: {},
      goodsList: [],
      isShowMore: false,
      isDescStatus: true,
      mapUrl: '',
      noteInfo: '',
      noticeShow: false,
      noticeInfo: {}
    }
  },

  computed: {
    commentGrade: function () {
      if (this.detailInfo && this.detailInfo.extInfo) {
        return JSON.parse(this.detailInfo.extInfo).commentGrade;
      }
      return "";
    }
  },

  created() {
    document.title = "景区详情"

    const id = this.$route.query.id || 0;

    getHospitalDetail(id).then(res => {
      this.detailInfo = res.data;
      this.mapUrl = `https://apis.map.qq.com/uri/v1/marker?marker=coord:${this.detailInfo.lat},${this.detailInfo.lng};title:${this.detailInfo.name};addr:${this.detailInfo.address}&referer=rcfl`;

      this.noteInfo = "开放时间：" + this.detailInfo.openTime;
      this.extInfo = JSON.parse(res.data.extInfo) || {};
      if (this.noteInfo.length > 10) {
        this.isShowMore = true;
      }
    })

    api_get_ctrip_goods_list(id).then(res => {
      this.goodsList = res.data || []

      if (this.goodsList.length < 1) {
        Dialog.confirm({ message: "此景区无门票产品,返回?" }).then(() => {
          history.back()
        })
      }
    })
  },

  methods: {
    go_travel_order_create(goods) {
      if (348 == goods.supplierId) { // 来一票 旅游门票
        this.$router.push({
          path: 'travel-order', query: {
            lyp_sn: goods.sn,
            brand_shop_id: this.$route.query.id
          }
        })
        return
      }

      this.$router.push({ path: 'travel-order', query: { goodsId: goods.goodsId } })
    },

    show_notice(goodsId) {
      const goods = this.goodsList.find(g => g.goodsId === goodsId);

      this.noticeShow = true;

      const goodsInfo = JSON.parse(goods.notice || "{}");
      const keysSorted = Object.keys(goodsInfo).sort((a, b) => {
        return a.substring(0, 1) - b.substring(0, 1);
      });

      for (let i = 0; i < keysSorted.length; i++) {
        this.noticeInfo[keysSorted[i].substring(1)] = goodsInfo[keysSorted[i]];
      }
    },

    showmoreDesc(e) {
      let el = e.currentTarget;
      el.previousElementSibling.classList[!this.isDescStatus ? 'add' : 'remove']('overflow-line');
      el.classList[this.isDescStatus ? 'add' : 'remove']('more-collapse');
      el.innerHTML = !this.isDescStatus ? '查看更多' : '收起';
      this.isDescStatus = !this.isDescStatus;
      this.isShowMore = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.span-price-65 {
  font-size: 18px;
  font-weight: bold;
  color: #f60;
  align-self: center
}

.travel-tag-9 {
  margin-right: 4px;
  margin-top: 8px;
}

div {
  margin: 0;
  border: 0;
  padding: 0;
}

.m-content {
  &.overflow-line {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
}

.btn-more {
  color: #5383E7;
}
</style>